import { SELECT_SORTING } from './sortDropdownConstants';
import { RECEIVE_PRODUCTS } from '../productList/productListConstants';

export const selectedSort = (state = '', action) => {
  switch (action.type) {
    case SELECT_SORTING:
      return action.sortName;
    case 'URL_HASH_APPLIED':
    case 'URL_HASH_CHANGED':
      return action.sort;
    case RECEIVE_PRODUCTS: {
      if (!action.mustValidateURLParams) {
        return state;
      }

      const selectedOption = action.searchMetadata.sortFields.find(option => option.selected);

      if (!selectedOption) {
        return state;
      }

      const validSelectedSort = selectedOption.code;

      if (validSelectedSort === 'relevance' && state === '') {
        return state;
      }

      return validSelectedSort;
    }
    default:
      return state;
  }
};
